export interface RenovationDetail {
  name: string;
  cost: number;
}
